/*
 * PluginDetails Messages
 *
 * This contains all the text for the PluginDetails component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.plugin.details';

export default defineMessages({
  pluginDetailsTitle: {
    id: `${scope}.pluginDetailsTitle`,
    defaultMessage: 'Plugin Details',
  },
  pluginIdTitle: {
    id: `${scope}.pluginIdTitle`,
    defaultMessage: 'Plugin ID',
  },
  pluginSettingsTitle: {
    id: `${scope}.pluginSettingsTitle`,
    defaultMessage: 'Plugin Settings',
  },
  pluginSettingsDescription: {
    id: `${scope}.pluginSettingsDescription`,
    defaultMessage: 'Restrict plugin publishing',
  },
  pluginSettingsPublishModeTitle: {
    id: `${scope}.pluginSettingsPublishModeTitle`,
    defaultMessage: 'Strict publish mode',
  },
  sharingTitle: {
    id: `${scope}.sharingTitle`,
    defaultMessage: 'Sharing',
  },
  developerTitle: {
    id: `${scope}.developerTitle`,
    defaultMessage: 'Developer',
  },
  pluginDevelopedBy: {
    id: `${scope}.pluginDevelopedBy`,
    defaultMessage: 'Developed by',
  },
  whatsNewTitle: {
    id: `${scope}.whatsNewTitle`,
    defaultMessage: 'What\'s new',
  },
  versionHistoryLink: {
    id: `${scope}.versionHistoryLink`,
    defaultMessage: 'Version History',
  },
  pluginDetailsDescription: {
    id: `${scope}.pluginDetailsDescription`,
    defaultMessage: 'Details used to find and identify your app. Learn more about creating apps in our {developerDocsLink} (passkey: brontebronte)',
  },
  developerDocsLink: {
    id: `${scope}.developerDocsLink`,
    defaultMessage: 'developer docs',
  },
  sharingDescription: {
    id: `${scope}.sharingDescription`,
    defaultMessage: 'Manage who has access to this plugin',
  },
  developerDescription: {
    id: `${scope}.developerDescription`,
    defaultMessage: 'Options for plugin developers. For more information visit the {developerDocsLink}',
  },
  settingsDescription: {
    id: `${scope}.settingsDescription`,
    defaultMessage: 'Copy the api key into your plugins manifest.json file. Learn more about ',
  },
  pluginSetupLink: {
    id: `${scope}.pluginSetupLink`,
    defaultMessage: 'setting up your plugin.',
  },
  addPeopleTitle: {
    id: `${scope}.addPeopleTitle`,
    defaultMessage: 'Add/remove people',
  },
  version: {
    id: `${scope}.version`,
    defaultMessage: 'version',
  },
  versionShort: {
    id: `${scope}.versionShort`,
    defaultMessage: 'V',
  },
  websiteLabel: {
    id: `${scope}.labelWebsite`,
    defaultMessage: 'Website',
  },
  developerEmailLabel: {
    id: `${scope}.developerEmailLabel`,
    defaultMessage: 'Developer email',
  },
  supportLabel: {
    id: `${scope}.supportLabel`,
    defaultMessage: 'Support',
  },
  copyLabel: {
    id: `${scope}.copyLabel`,
    defaultMessage: 'Copy',
  },
  copyNotificationLabel: {
    id: `${scope}.copyNotificationLabel`,
    defaultMessage: 'Copied',
  },
  pluginSchemaTitle: {
    id: `${scope}.pluginSchemaTitle`,
    defaultMessage: 'Schema',
  },
  pluginSchemaDescription: {
    id: `${scope}.pluginSchemaDescription`,
    defaultMessage: 'The latest plugin schema (version {version}). Learn more about schemas in our {developerDocsLink}',
  },
});
